<template>
    <v-navigation-drawer v-model="isActive" class="app-menu-panel" app left temporary>
        <app-button v-test-id="{ action: 'hide_menu' }" icon="close" class="ma-3" @click="() => (isActive = false)" />
        <app-nav-menu :items="items" />
    </v-navigation-drawer>
</template>

<script>
import getMenu from '@/router/lib/getMenu';
import { mapGetters } from 'vuex';

export default {
    name: 'AppMenuPanel',
    components: {
        AppNavMenu: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppNavMenu'
            )
    },
    data: () => ({
        items: []
    }),
    computed: {
        ...mapGetters('system', ['menuPanelActive']),
        isActive: {
            get() {
                return this.menuPanelActive;
            },
            set(v) {
                this.$store.dispatch('system/setMenuPanel', v);
            }
        }
    },
    methods: {
        async setup() {
            this.items = await getMenu('primary');
        }
    }
};
</script>
